import { render, staticRenderFns } from "./GerarOrdemColetaFilterBar.vue?vue&type=template&id=075ce4f4"
import script from "./GerarOrdemColetaFilterBar.vue?vue&type=script&lang=js"
export * from "./GerarOrdemColetaFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports